import React from 'react'
import { Link } from 'react-router-dom'
import config from '../../../config.json'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'


const ChooseCinema = ({
    cinemaOrder,
    cinemaItems,
    basicUrl,
    closePagePath,
    printChooseCinema
}) => (
    <WrapperPageSimple
        pageTitleTransId={config.routes.webtoprint.transId}
        closePagePath={closePagePath}
    >
         <div className="site-content">
            {cinemaOrder.length > 0 ? (
                <div className="link-container">   
                    {cinemaOrder.map((cinemaId) => (
                        <div
                            key={cinemaId} 
                            className={"link-container-item title-large-light cursor-pointer"}
                            onClick={() => printChooseCinema(cinemaId, `${basicUrl}/${cinemaId}`)}
                        >
                             {cinemaItems[cinemaId].nameDisplay}
                        </div>
                    ))}
                </div>
            ): (
                <div>Keine Kinos gefunden</div>
            )}
         </div>

    </WrapperPageSimple>

)

export default ChooseCinema